export default "__VITE_ASSET__Bu4XC_Xn__"